import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["message"]
  static values = {
    autoHide: { type: Boolean, default: true },
    delay: { type: Number, default: 5000 }
  }

  connect() {
    this.messageTargets.forEach(message => {
      if (this.autoHideValue) {
        setTimeout(() => {
          this.dismiss({ target: message })
        }, this.delayValue)
      }
    })
  }

  dismiss(event) {
    const message = event.target.closest('[data-flash-target="message"]')
    if (!message) return

    // Add fade out animation
    message.classList.add('transition-opacity', 'duration-300', 'ease-in-out')
    message.style.opacity = '0'
    
    // Remove after animation
    setTimeout(() => {
      message.remove()
    }, 300)
  }
}
